import { formatUserFacingError } from '@/utils/userFacingError';

export function formatTerminalConnectionError(error: unknown): string {
  return formatUserFacingError(error, 'Unable to connect card reader.');
}
